import i18next from 'i18next'
const ApprovalTypes = {
  NOOWNERDECISIONWITHREJECTS: 'noownerdecisionwithrejects',
  ALLAPPROVERSMUSTAPPROVE: 'allapproversmustapprove',
  OWNERDECISIONWITHREJECTS: 'ownerdecisionwithrejects',
  properties: {
    noownerdecisionwithrejects: {
      key: 'noownerdecisionwithrejects',
      value: 'No owner decision with rejects'
    },
    allapproversmustapprove: {
      key: 'allapproversmustapprove',
      value: 'All approvers must approve'
    },
    ownerdecisionwithrejects: {
      key: 'ownerdecisionwithrejects',
      value: 'Owner decision with rejects'
    }
  }
}

const TaskListTypes = {
  ALL: 'all',
  SUBMIT: 'submit',
  SENDFORDECISION: 'sendfordecision',
  ENABLEOWNERDECISIONTOOCCUR: 'enableownerdecisiontooccur',
  PROCEEDWITHIMPLEMENTATION: 'proceedwithimplementation',
  CONFIRMCHANGEISINPLACE: 'confirmchangeisinplace',
  CONFIRMCHANGEISFULLYIMPLEMENTED: 'confirmchangeisfullyimplemented',
  properties: {
    all: {
      key: 'all',
      value: 'All'
    },
    submit: {
      key: 'submit',
      value: 'Submit'
    },
    sendfordecision: {
      key: 'sendfordecision',
      value: 'Send for Decision'
    },
    enableownerdecisiontooccur: {
      key: 'enableownerdecisiontooccur',
      value: 'Enable Owner Decision to Occur'
    },
    proceedwithimplementation: {
      key: 'proceedwithimplementation',
      value: 'Proceed with Implementation'
    },
    confirmchangeisinplace: {
      key: 'confirmchangeisinplace',
      value: 'Confirm change is in place'
    },
    confirmchangeisfullyimplemented: {
      key: 'confirmchangeisfullyimplemented',
      value: 'Confirm change is fully implemented'
    }
  }
}

const ChangeTypes = {
  TEMPORARY: 'temporary',
  PERMANENT: 'permanent',
  BOTH: 'both',
  properties: {
    temporary: {
      key: 'temporary',
      value: 'Temporary'
    },
    permanent: {
      key: 'permanent',
      value: 'Permanent'
    },
    both: {
      key: 'both',
      value: 'Both'
    }
  }
}

const AnswerTypes = {
  DROPDOWN: 'dropdown',
  MULTISELECT: 'multiselect',
  TEXT: 'text',
  properties: {
    dropdown: {
      key: 'dropdown',
      value: 'Single Select List',
      dependants: true,
      options: true
    },
    text: {
      key: 'text',
      value: 'Text'
    },
    multiselect: {
      key: 'multiselect',
      value: 'Multi Select List',
      dependants: false,
      options: true
    }
  }
}

const DecisionTypes = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  properties: {
    approved: {
      key: 'approved',
      value: i18next.t('Approve')
    },
    rejected: {
      key: 'rejected',
      value: i18next.t('Reject')
    }
  }
}

export { ApprovalTypes, TaskListTypes, ChangeTypes, AnswerTypes, DecisionTypes }
